import { render, staticRenderFns } from "./ViewedCustomerProfile.vue?vue&type=template&id=70a9509a"
import script from "./ViewedCustomerProfile.vue?vue&type=script&lang=js"
export * from "./ViewedCustomerProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports